
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { SidebarMenu } from 'vue-sidebar-menu';
import { MenuGroup } from '@/services/MenuGroup';
import { MenuItem } from '@/services/MenuItem';
import { General } from '@/services/General';
import { ClaimEnum } from '@/services/ClaimEnum';
import { i18n } from '@/i18n/i18n-setup';

@Component({
    components: {
        SidebarMenu
    }
})

export default class SideMenu extends Vue {
    navItems: Array<MenuGroup | MenuItem> = [            
            new MenuGroup(i18n.t('MENU.PRODUCTS') as string,{
                element: "img", //'fa lubricantIcon',
                class : 'fa lubricantIcon text-primary ',
                attributes: {src: "../images/lubricantIcon.svg?ver=2"}
            }, 
            [
                new MenuItem(i18n.t('MENU.PRODUCT_SEARCH') as string, '/products', ClaimEnum.CanSearchProduct, '/products/:id'),
                new MenuItem(i18n.t('MENU.MATERIALS_SEARCH') as string,  '/materials',ClaimEnum.CanSearchMaterial),
                new MenuItem(i18n.t('MENU.SPECIFICATIONS_UPLOAD') as string, '/product-specs-upload', ClaimEnum.CanUploadTechSpecs),
                new MenuItem(i18n.t('MENU.MATERIAL_INFO_UPLOAD') as string, '/material-info-upload', ClaimEnum.CanUploadMaterialInfo),
                new MenuItem(i18n.t('MENU.DOCUMENTATION_UPLOAD') as string, '/document-upload', ClaimEnum.CanUploadDocument),
                new MenuItem(i18n.t('MENU.DOCUMENTATION DOWNLOAD') as string, '/document-download', ClaimEnum.CanExportZip),
                new MenuItem(i18n.t('MENU.LABEL_REPOSITORY') as string,'/label-repository',ClaimEnum.CanViewMaterialLabel)
            ]),
            new MenuGroup(i18n.t('MENU.CERTIFICATES') as string,'fa fa-certificate',[
                new MenuItem( i18n.t('MENU.CQC') as string, '/cqc', ClaimEnum.CanManageCQC)
            ]),
            new MenuGroup(i18n.t('MENU.LUBRIFICATION_TABLE') as string, 'fa fa-flask', [
                new MenuItem(i18n.t('MENU.GROUPS') as string, '/groups', ClaimEnum.CanViewLubTable, '/groups/:id'), 
                new MenuItem(i18n.t('MENU.VEHICLES') as string, '/vehicles', ClaimEnum.CanViewLubTable, '/vehicles/:id') 
            ]),
            new MenuGroup(i18n.t('MENU.EMPLOYEE_PORTAL') as string, 'fa fa-envelope',  [
                new MenuItem(i18n.t('MENU.ARCHIVE') as string, '/communications', ClaimEnum.CanShowCommunications, '/communications/:id'),
                new MenuItem(i18n.t('MENU.CATEGORIES') as string, '/communicationsCategories', ClaimEnum.CanManageCommunicationCategories, '/communicationsCategories/:id')
            ]),
            new MenuGroup(i18n.t('MENU.NET20') as string,  'fa fa-line-chart',  [
                new MenuItem(i18n.t('MENU.CUSTOMER_SEARCH') as string, '/net20s', ClaimEnum.CanManageNet20, '/net20s/:id'),
                new MenuItem(i18n.t('MENU.WELCOME_KIT') as string, '/welcome-kit-info', ClaimEnum.CanManageNet20),
                new MenuItem(i18n.t('MENU.REPORT_CONTRACT_AGREEMENT') as string, '/report-contract-renewals', ClaimEnum.CanManageNet20),
                new MenuItem(i18n.t('MENU.USERS_NET20_MANAGEMENT') as string, '/users-net20-management', ClaimEnum.CanAdminNet20),
                new MenuItem(i18n.t('MENU.GEOLOCATOR') as string, '/geolocator', ClaimEnum.CanDownloadGeolocator),
            ]),
            new MenuGroup(i18n.t('MENU.PPE') as string, 'fa fa-shopping-cart', [
                new MenuItem(i18n.t('MENU.PPE_SEARCH') as string, '/ppes', ClaimEnum.CanManagePpe, '/ppes/:id'),
                new MenuItem(i18n.t('MENU.PPE_EURO') as string, '/merchandising-report/', ClaimEnum.CanManagePpe),
                new MenuItem(i18n.t('MENU.PPE_USER_MANAGEMENT') as string, '/users-ppe-management/', ClaimEnum.CanAdminPpe),
            ]),
            new MenuGroup(i18n.t('MENU.PK') as string, 'fa fa-cube', [
                new MenuItem(i18n.t('MENU.PK_CAPITOLATI_SEARCH') as string, '/capitolati-search', ClaimEnum.CanViewPackaging, '/capitolato/:id'),
                new MenuItem(i18n.t('MENU.PK_CONTENITOREGRAFICHE_SEARCH') as string, '/contenitore-grafiche-search', ClaimEnum.CanViewPackaging, '/contenitore/:id'),
                new MenuItem(i18n.t('MENU.PK_PALLETTIZZAZIONI_SEARCH') as string, '/pallettizzazioni-search', ClaimEnum.CanViewPackaging),
                new MenuItem(i18n.t('MENU.PK_PESI_IMBALLI_SEARCH') as string, '/pesi-imballi-search', ClaimEnum.CanViewPackaging)
            ]),
            new MenuGroup(i18n.t('MENU.ANAGRAPHY') as string,'fa fa-list-alt',  [
                new MenuItem(i18n.t('MENU.WORKSHOPS_SEARCH') as string, '/signs', ClaimEnum.CanManageSigns, '/signs/:id')
            ]),
            new MenuGroup(i18n.t('MENU.ADMIN_MANAGEMENT') as string,'fa fa-gears',  [
                new MenuItem(i18n.t('MENU.USER_MANAGEMENT') as string, '/usermanagement', ClaimEnum.CanAdmin),
            ]),
            new MenuGroup(i18n.t('MENU.HR_MANAGEMENT') as string,'fa fa-users',  [
                new MenuItem(i18n.t('MENU.EMERGENCY_MANAGEMENT') as string, '/emergency-contact-management', ClaimEnum.CanManageEmergencyContacts)
            ]),
            new MenuItem(i18n.t('MENU.HELP') as string,'' , null, null, [], 'fa fa-question-circle', false, true)
    ];

    @Prop({ default: true })
    sideActive: boolean = true;
    itemTile: string = "";
    itemUrl: string = "";
    itemClaim: string = "";

    sideMenu() {
        this.$emit('sideMenu');
    }

    onItemClick(event, item : MenuGroup | MenuItem, node) {
        if(item instanceof MenuItem && item.OpenModal){
    
            this.$bvModal.show('modal-1')
        }
    }

    getCurrentMenuItem(): MenuItem {
        for (let item of this.navItems) {
            for (let menuItem of item.child) {

                if (menuItem instanceof MenuItem && this.cleanUrl(menuItem.href) == this.cleanUrl(this.$router.currentRoute.path)) {
                    this.itemTile = menuItem.title;
                    this.itemUrl = menuItem.href;
                    this.itemClaim = menuItem.Claim;
                    return menuItem;
                }
            }
        }
        return new MenuItem(this.itemTile, this.itemUrl, this.itemClaim,);
    }

    cleanUrl(path: string) {
        if (path.includes('/:id')) {
            let id: string = '';
            if (this.$route.params.id)
                id = this.$route.params.id;
            return path.replace('/:id', '/' + id);
        }
        return path;
    }
    mounted(){
        //let menuNodes = this.navItemsGroupOnlyActive
        
        
    }
    get navItemsGroupOnlyActive(): Array<MenuGroup | MenuItem> {
        let activeCounter = 0;
        let lastActiveNode: MenuItem = null;
        let navItemsComputed: Array<MenuGroup | MenuItem> = new Array();
        let isActive = false;
        this.navItems.forEach(group => {
            isActive = false;
            if (
                (group instanceof MenuItem && group.Claim == null) 
                || (group instanceof MenuItem && group.Claim != null && General.CheckAuthorization(group.Claim))
                ) 
            {               
                navItemsComputed.push(group);
                return;
            }
            group.child.forEach(item => {
                if (
                    (item instanceof MenuItem && item.Claim == null) 
                    || (item instanceof MenuItem && item.Claim != null && General.CheckAuthorization(item.Claim))
                    
                    ) 
                {
                    activeCounter++;
                    lastActiveNode = item;
                    item.Active = true;
                    isActive = true;

                }
            });
            if (isActive) {
                group.child = group.child.filter(x => x.Active)
                navItemsComputed.push(group);
            }
        });
        
        if (activeCounter==1) {
            
            this.$store.dispatch('setSingleMenuItem', lastActiveNode);       
        }
        else
            this.$store.dispatch('setSingleMenuItem', null);       
        
        return navItemsComputed;
    }
}

